import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import MetaPixel from './components/MetaPixel';
export function AppRouter() {
  // Activar el depurador de pixel solo en desarrollo
  const isDebugMode = process.env.NODE_ENV !== 'production';
  return <BrowserRouter data-id="element-18">
      <MetaPixel debug={isDebugMode} data-id="element-19">
        <Routes data-id="element-20">
          <Route path="/" element={<App data-id="element-22" />} data-id="element-21" />
          {/* Aquí se añadirán futuras rutas */}
        </Routes>
      </MetaPixel>
    </BrowserRouter>;
}